import { render, staticRenderFns } from "./ModalAddReason.vue?vue&type=template&id=41136107&"
import script from "./ModalAddReason.vue?vue&type=script&lang=js&"
export * from "./ModalAddReason.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports